// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1v65vgT2xlyOTC {\n  margin-left: 4px;\n  margin-bottom: 0;\n  color: #0079BF;\n  font-size: 16px;\n  line-height: 30px;\n}\n._1v65vgT2xlyOTC:hover,\n._1v65vgT2xlyOTC:focus {\n  color: #298FCA;\n}\n._3PslHDj1ZsATVQ {\n  margin-left: 6px;\n  margin-bottom: 0;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"viewLink": "_1v65vgT2xlyOTC",
	"viewIcon": "_3PslHDj1ZsATVQ"
};
export default ___CSS_LOADER_EXPORT___;
